import * as React from "react";
const SvgFiRrEditAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-edit-alt_svg__a)">
      <path d="M9.288 13.067c-2.317.446-3.465 3.026-3.963 4.634A1 1 0 0 0 6.281 19H10a3 3 0 0 0 2.988-3.274 3.11 3.11 0 0 0-3.7-2.659" />
      <path d="M23 8.979a1 1 0 0 0-1 1V15h-4a3 3 0 0 0-3 3v4H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h11.042a1 1 0 1 0 0-2H5a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h11.343a4.97 4.97 0 0 0 3.535-1.464l2.658-2.658A4.97 4.97 0 0 0 24 16.343V9.979a1 1 0 0 0-1-1m-4.536 12.143c-.403.399-.91.676-1.464.8V18a1 1 0 0 1 1-1h3.925a3 3 0 0 1-.8 1.464z" />
      <path d="M14.566 14.17a1 1 0 0 1-.707-1.707l7.853-7.853a.94.94 0 0 0 0-1.335.9.9 0 0 0-.694-.275.93.93 0 0 0-.678.314l-7.6 8.407a1 1 0 1 1-1.484-1.341l7.6-8.4A2.95 2.95 0 0 1 20.963 1a2.99 2.99 0 0 1 2.163.862 2.947 2.947 0 0 1 0 4.163l-7.853 7.853a1 1 0 0 1-.707.292" />
    </g>
    <defs>
      <clipPath id="fi-rr-edit-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEditAlt;
